import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProductsService } from '../../../services/product/products.service';
import { CategoriesEnum } from '../../../shared/models/app/info-enum';
import ProductFilter from '../../../shared/models/product/product-filter';

export const featuredProductsResolver: ResolveFn<any> = () => {
  const productService = inject(ProductsService);

  const filter: ProductFilter = new ProductFilter();
  filter.inactive = false;
  filter.ignoreMainVariation = true;
  filter.featured = true;
  filter.categories = [CategoriesEnum.PERSIANAS];
  filter.perPage = 20;

  return productService.products(filter);
};
